import React, { useState, useEffect, useRef } from "react";
import { baseURL } from "../utils/config";
import "../components/ProductDetail.css";
import { IoArrowForward } from "react-icons/io5";
import BlogImage from "../assets/images/Blog.png";
import { Helmet } from "react-helmet-async";
import productDetail from "../assets/images/product-details.svg";
import productDetail1 from "../assets/images/SpiralWoundGasket.svg";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { Box, CircularProgress, Divider } from "@mui/material";

const BlogDetail = () => {
  const [screenWidth, setScreenWidth] = useState(0);
  const [blogDetails, setBlogDetails] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();
  const scrollableSectionRef = useRef(null);

  useEffect(() => {
    // Lock scrolling on the body
    document.body.classList.add("scroll-lock");

    // Enable scrolling on the specific section
    if (scrollableSectionRef.current) {
      scrollableSectionRef.current.style.overflowY = "auto"; // or 'scroll' to always show scrollbar
      scrollableSectionRef.current.style.maxHeight = "80vh"; // Set a max height for the section
    }

    return () => {
      // Remove scroll lock on unmount
      document.body.classList.remove("scroll-lock");
    };
  }, []);

  const blogId = location.state?.blogId;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const data = [
    {
      id: 1,
      questions:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua?",
      answer:
        "Impressions are a big deal when it comes to oSed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.",
    },
    {
      id: 2,
      questions:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua?",
      answer:
        "Impressions are a big deal when it comes to oSed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.",
    },
    {
      id: 3,
      questions:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua?",
      answer:
        "Impressions are a big deal when it comes to oSed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.",
    },
  ];
  const [productTab, setProductTab] = useState("products");
  const handleProduct = (tab) => {
    console.log(tab);
    setProductTab(tab);
  };
  const [toggledStates, setToggledStates] = useState({
    product: false,
    size: false,
    specification: false,
    keyfeatures: false,
  });

  const handleToggle = (section) => {
    setToggledStates((prevState) => ({
      ...prevState,
      [section]: !prevState[section],
    }));
  };

  useEffect(() => {
    // Create a new ResizeObserver instance
    const resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        setScreenWidth(entry.contentRect.width);
      }
    });

    // Start observing the selected element
    resizeObserver.observe(document.body);
  }, [screenWidth]);
  const isMobile = screenWidth <= 600;
  useEffect(() => {
    const getData = async () => {
      try {
        const response = await axios.get(
          `${baseURL}/api/blogs?filters[id][$eq]=${blogId}&populate[product_details][populate]=*&populate[related_blogs][populate]=*`
        );
        setBlogDetails(response.data.data);
      } catch (error) {
        console.error("Error fetching data: ", error);
      }
    };

    getData();
  }, [blogId]);

  // console.log(blogDetails?.[0]?.attributes?.product_details, "data qqew");

  useEffect(() => {
    // Simulate loading delay
    const timer = setTimeout(() => setIsLoading(false), 2000); // Adjust delay as needed
    return () => clearTimeout(timer);
  }, []);

  return isLoading ? (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundColor: "#f5f5f5",
      }}
    >
      <CircularProgress />
    </Box>
  ) : (
    <>
      <Helmet>
        <title>{blogDetails?.[0]?.attributes?.title}</title>
        <link
          rel="canonical"
          href={`https://uniklinger.com/insights/${blogDetails?.[0]?.attributes?.slug}`}
        />
        <meta
          itemProp="description"
          content={blogDetails?.[0]?.attributes?.metaDescription}
        />
        <meta
          itemProp="keyword"
          metaKeyword={blogDetails?.[0]?.attributes?.metaKeywords}
        />
      </Helmet>
      <div
        className="fluid-container"
        // {
        //   screenWidth > 600
        //     ? " pt-120 fluid-container"
        //     : " pl-[1%] pr-[1%] fluid-container "
        // }
        itemScope
        itemType="https://schema.org/Product"
        style={{ paddingTop: isMobile ? "50px" : "80px" }}
      >
        <div
          className=" product-details-container flex item-center h-450"
          itemProp="mainEntity"
          itemScope
          itemType="https://schema.org/Product"
        >
          <div
            // ref={scrollableSectionRef}
            // className="scrollable-section col-md-8 grid gap-10"
            className="col-md-8 grid gap-2"
            style={{ height: "100%" }}
            // style={{ height: "100%", overflowY: "auto" }}
          >
            <div>
              <h1
                style={{
                  fontSize: "20px",
                  fontWeight: 700,
                  textAlign: "start",
                }}
              >
                {blogDetails?.[0]?.attributes?.title}
              </h1>
            </div>
            <Divider />
            <div className=" flex flex-row" style={{ marginTop: "10px" }}>
              <div
                style={{ backgroundColor: "#D4DDE7", color: "#221F20AB" }}
                className="blogTags "
                itemProp="name"
              >
                {blogDetails?.[0]?.attributes?.metaKeywords}
              </div>
              <div
                style={{
                  backgroundColor: "#221F200F",
                  color: "#221F20AB",
                }}
                className="blogTags ml-2"
                itemProp="name"
              >
                {blogDetails?.[0]?.attributes?.read}
                min Read
              </div>
            </div>
            {/* <div style={{fontWeight: "bold", fontSize: "20px"}}>{blogDetails?.[0]?.attributes?.title}</div> */}
            <div
              dangerouslySetInnerHTML={{
                __html:
                  blogDetails?.[0]?.attributes?.details?.details?.content.replace(
                    /\n/g,
                    "<br />"
                  ),
              }}
              className="product-card-subtitle fullWidth text-[16px]"
              itemProp="description"
            >
              {/* {blogDetails?.[0]?.attributes?.details?.details?.content} */}
            </div>
            <div className="w-full col-md-12 p-[0px] inline-flex md:inline-flex gap-4 flex-wrap md:flex-wrap">
              {blogDetails?.[0]?.attributes?.product_details?.data?.length >
                0 &&
                blogDetails?.[0]?.attributes?.product_details?.data?.map(
                  (product, index) => (
                    <div
                      className="industry-card w-full lg:w-[48%] overflow-hidden" // Ensures equal width for all cards
                      key={index}
                      itemScope
                      itemType="https://schema.org/Product"
                    >
                      <div>
                        <div className=" flex justify-center">
                          <img
                            // src={product.imgSrc}
                            src={baseURL.concat(
                              product?.attributes?.Thumbnail?.data?.attributes
                                ?.url
                            )}
                            style={{
                              height: isMobile ? 150 : 269,
                              width: "auto",
                            }}
                            className="industry-image"
                            itemProp="image"
                          />
                        </div>
                        <div
                          className="industry-content p-2"
                          style={{
                            backgroundColor: "#E7ECF4",
                            minHeight: "80px",
                          }}
                        >
                          <div className="flex flex-row items-center justify-between p-3">
                            <div
                              style={{
                                fontFamily: "DM Sans",
                                fontWeight: 700,
                                fontSize: 16,
                              }}
                            >
                              {product?.attributes?.Title}
                              <br />
                              <span>{product.subtitle}</span>
                            </div>
                            <div>
                              <a
                                href={"/products/" + product?.attributes?.slug}
                              >
                                <button
                                  style={{
                                    marginTop: 0,
                                    fontSize: isMobile ? "12px" : "14px",
                                    whiteSpace: "nowrap", // Prevents text from wrapping
                                    padding: "5px 10px", // Adjust padding for better fit
                                  }}
                                  className="view-product text-center d-flex items-center"
                                >
                                  View Product
                                  <span></span>
                                </button>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                )}
            </div>
          </div>

          <div className="col-md-4 product-details">
            {blogDetails?.[0]?.attributes?.related_blogs?.data?.length > 0 && (
              <div
                className="flex justify-between items-center mt-10 product-title-container"
                itemScope
                itemProp="name"
              >
                <div className="product-detail-title">
                  <span className="poppins" style={{ fontSize: 20 }}>
                    Related <span className="font-bold">Blogs</span>
                  </span>
                </div>
              </div>
            )}

            {blogDetails?.[0]?.attributes?.related_blogs?.data?.map((item) => (
              <div
                className="industry-card mt-[15px]"
                itemScope
                itemType="https://schema.org/Product"
                key={item?.id}
              >
                <div className="flex justify-center">
                  <img
                    src={baseURL.concat(
                      item?.attributes?.image?.data?.[0]?.attributes?.url
                    )}
                    // src={BlogImage}
                    style={{ height: 180, width: "auto" }}
                    className="industry-image"
                    itemProp="image"
                  />
                </div>
                <div className="industry-content bg-white p-[10px]">
                  <div className=" flex flex-row pb-10 ">
                    <div
                      style={{ backgroundColor: "#D4DDE7", color: "#221F20AB" }}
                      className="blogTags "
                      itemProp="name"
                    >
                      {/* Lifestyle */}
                      {item?.attributes?.type}
                    </div>
                    <div
                      style={{
                        backgroundColor: "#221F200F",
                        color: "#221F20AB",
                      }}
                      className="blogTags ml-2"
                      itemProp="name"
                    >
                      {item?.attributes?.read} min Read
                    </div>
                  </div>

                  <div
                    className="blog-description pb-10"
                    itemProp="description"
                  >
                    {/* Providing unique solutions that address shortcomings in
                    existing products. */}
                    {item?.attributes?.title}
                  </div>
                  <div className="flex flex-row justify-between items-center">
                    <div className="poppins" style={{ fontSize: 14 }}>
                      {/* 19 Feb, 2023 */}
                      {item?.attributes?.createdDate}
                    </div>
                    <div>
                      <div className="md:mt-[0px] mt-10 d-flex items-center">
                        <a
                          href={"/insights/" + item?.attributes?.slug}
                          // title="About Us"
                          className="font-semibold text-black text-[14px] md:text-[16px] m-2 md:pt-3"
                        >
                          Know More
                        </a>
                        <IoArrowForward className="text-black md:m-2 origin-bottom -rotate-45 size-5 md:size-8" />
                      </div>
                      <div
                        className="gradLine"
                        style={{
                          marginLeft: 7,
                          width: "120px",
                        }}
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default BlogDetail;
